<template>
  <div class="d-flex flex-row container-info-helper">
    <div
      class="nav flex-column nav-pills w-25"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <a
        class="nav-link"
        v-for="(video, index) in videos"
        :class="{'active' : tabSelected === video.id}"
        :id="`${video.id}-tab`"
        data-toggle="pill"
        :href="`#${video.id}`"
        role="tab"
        :aria-controls="`${video.id}`"
        aria-selected="false"
        @click.prevent="changeTab(video)"
      >{{ video.title }}</a>
    </div>
    <div class="tab-content w-75 px-3" id="v-pills-tabContent">
      <div
        class="tab-pane"
        v-for="(video, index) in videos"
        :class="tabSelected === video.id ? 'show active' : 'fade'"
        :id="`${video.id}`"
        role="tabpanel"
        :aria-labelledby="`${video.id}-tab`"
      >
        <p class="text-center py-1">{{ video.title }}</p>
        <iframe
          :src="`${video.src}`"
          v-if="video.type === 'vimeo'"
          width="100%"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
        <iframe
          v-else
          width="100%"
          height="360"
          :src="`${video.src}`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  name: 'InfoHelper',
  props: ['tabSelected'],

  data() {
    return {
      videos: [
        {
          id: 'overview',
          title: this.$t('ct-overview'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/vv_mg56q5gI'
        },

        {
          id: 'website-settings',
          title: this.$t('ct-website-settings'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/QqvrvToS8lk'
        },

        {
          id: 'add-new-page',
          title: this.$t('ct-add-new-page'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/f1J1IQH7Tm0'
        },

        {
          id: 'editing-mobile',
          title: this.$t('ct-editing-mobile'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/z2zNHo2vDyo'
        },

        {
          id: 'panels',
          title: this.$t('ct-panels'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/8qPHpjHnmhw'
        },

        {
          id: 'editor-overview',
          title: this.$t('ct-editor-overview'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/kvs4XNvPKug'
        },

        {
          id: 'headers-and-footers',
          title: this.$t('ct-headers-and-footers'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/wPmymunz5Qw'
        },

        {
          id: 'tab-add',
          title: this.$t('ct-add'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/4KPPVfn3Fgg'
        },

        {
          id: 'tab-settings',
          title: this.$t('ct-settings'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/1zlA55K5AxU'
        },

        {
          id: 'tab-personal',
          title: this.$t('ct-personal'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/as3726jVFEw'
        },

        {
          id: 'email-mkt-form',
          title: this.$t('ct-email-mkt-form'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/Bd7azK9XBMU'
        },

        {
          id: 'tab-elements',
          title: this.$t('ct-elements'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/kpy_phn2U28'
        },

        {
          id: 'boxes',
          title: this.$t('ct-boxes'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/8oH5kwlEBuc'
        },

        {
          id: 'buttons',
          title: this.$t('ct-buttons'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/PULYUvjF094'
        },

        {
          id: 'iframe',
          title: this.$t('ct-iframe'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/Mx_Rvu4CkuQ'
        },

        {
          id: 'text',
          title: this.$t('ct-text'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/zBx7RtCmNmw'
        },

        {
          id: 'videos',
          title: this.$t('ct-videos'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/0UZGrqRdBqk'
        },

        {
          id: 'preset-fonts',
          title: this.$t('ct-preset-fonts'),
          type: 'youtube',
          src: 'https://www.youtube.com/embed/Sp_xh7l3Qgc'
        },
        {
          id: 'imageSizeMobile',
          title: this.$t('ct-imageSizeMobile'),
          type: 'vimeo',
          src:
            'https://player.vimeo.com/video/365568892?title=0&byline=0&portrait=0'
        },
        {
          id: 'fontSizeMobile',
          title: this.$t(
            'ct-fontSizeMobile'),
          type: 'vimeo',
          src:
            'https://player.vimeo.com/video/365568790?title=0&byline=0&portrait=0'
        },
        {
          id: 'addElements',
          title: this.$t('ct-addElements'),
          type: 'vimeo',
          src:
            'https://player.vimeo.com/video/365568686?title=0&byline=0&portrait=0'
        },
        {
          id: 'savePanelsTab',
          title: this.$t('ct-savePanelsTab'),
          type: 'vimeo',
          src:
            'https://player.vimeo.com/video/365568922?title=0&byline=0&portrait=0'
        }
      ]
    };
  },

  watch: {
    tabSelected: function(value) {
      this.clearActives();
    }
  },

  methods: {
    clearActives() {
      var div = document.querySelectorAll('.container-info-helper .tab-pane');
      var links = document.querySelectorAll('.nav-link.active');

      Object.keys(links).forEach(index => {
        links[index].classList.remove('active');
      });

      Object.keys(div).forEach(index => {
        var divContent = div[index];
        divContent.classList.remove('active');
        divContent.classList.remove('show');
      });
    },

    changeTab(video) {
      this.$loading.show();
      this.clearActives();

      setTimeout(function() {
        var div = document.querySelectorAll(
          '.container-info-helper .tab-pane:not(.active)'
        );

        Object.keys(div).forEach(index => {
          var iframe = div[index].querySelector('iframe');
          var divContent = div[index];

          if (divContent.id !== video.id) {
            divContent.classList.remove('active');
            divContent.classList.remove('show');

            if (iframe) {
              if (iframe.src.indexOf('player.vimeo.com') > -1) {
                try {
                  var player = new Player(iframe);
                  player.pause();
                } catch (e) {
                  console.warn(e);
                }
              } else {
                $(div)
                  .find('iframe')
                  .each(function() {
                    var src = $(this).attr('src');
                    $(this).attr('src', src);
                  });
              }
            }
          }
        });
      }, 350);

      setTimeout(function() {
        let body = document.getElementsByTagName('body')[0];
        body.classList.remove('loading');
      }, 800);
    }
  }
};
</script>

<style lang="scss">
  .container-info-helper{
    overflow: auto;

    .nav-pills, .tab-content{
      height: auto;
      max-height: 500px;
      overflow: auto;
      flex-wrap: nowrap;
    }

    .tab-content{
      height: auto;
      max-height: 500px;
      overflow: auto;
    }

    .tab-content .tab-pane.show{
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/base/InfoHelper.vue